import apiUrl from '../baseUrls/functions';
import AxiosService from '../axiosConfig/AxiosService';

export default new class MaintenanceService {
    
    get = (callback, queryParams) => AxiosService.get(apiUrl('/api/crud/maintenance/get'), callback, queryParams);
    getById = (id, callback) => AxiosService.get(apiUrl(`/api/crud/maintenance/get/${id}`), callback);
    add = (data, callback) => AxiosService.post(apiUrl('/api/crud/maintenance/add'), data, callback);
    update = (data, callback) => AxiosService.put(apiUrl('/api/crud/maintenance/update'), data, callback);
    delete = (id, callback) => AxiosService.delete(apiUrl(`/api/crud/maintenance/delete/${id}`), callback);
    
}